/**
 * Header.js
 * 版本：V1.01 | 更新日期：2025-07-16 16:35:00
 * 功能：頁面標題組件，包含登入狀態和操作按鈕
 * 關連檔案：App.js
 */

import React from 'react';

const Header = ({ currentUser, onLogout, onLoginClick, onAccountClick }) => ( 
    <header className="flex justify-between items-center mb-4 pb-4 border-b"> 
        <h1 className="text-xl sm:text-2xl font-bold text-gray-900">童顏家行程日曆</h1> 
        {currentUser ? ( 
            <div className="flex items-center gap-2"> 
                <p className="text-sm text-gray-600 hidden sm:block">歡迎, {currentUser.name}</p> 
                <p className="text-sm font-semibold text-gray-800">({currentUser.id})</p> 
                <button onClick={onAccountClick} className="text-xs bg-gray-500 hover:bg-gray-600 text-white font-semibold py-1 px-2 rounded-md transition">我的帳號</button> 
                <button onClick={onLogout} className="text-xs bg-red-500 hover:bg-red-600 text-white font-semibold py-1 px-2 rounded-md transition">登出</button> 
            </div> 
        ) : ( 
            <div className="flex items-center gap-2">
                <button onClick={onLoginClick} className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-lg">登入</button>
            </div>
        )} 
    </header> 
);

export default Header; 